import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  dialogRoot: {
    color: '#32324D',
    borderRadius: '4px'
  }
}));

export default useStyles;
